import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ResponseModel } from '@_core/models/response';
import { API } from '@quantum-theme/core/_config/api/api';
import { saveAs } from 'file-saver';

@Injectable()
export class FileService {
  constructor(
    private http: HttpClient
  ) { }

  uploadFile(file): Observable<ResponseModel> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    return this.http.post<ResponseModel>(API.file, formData);
  }

  // 获取视频上传凭证
  uploadAliyunFile(fileName): Observable<ResponseModel> {
    return this.http.get<ResponseModel>(API.aliyun + '/uploadCertificate/' + fileName);
  }

  // 获取上传后的url
  getAliyunFileUrl(videoId): Observable<ResponseModel> {
    return this.http.get<ResponseModel>(API.aliyun + '/playInfo/' + videoId);
  }

  downloadFileFromEncodedStream(url: string, fileName?: string): void {
    this.getFileStream(url).subscribe(fs => {
      const decodedFilename = fileName ? fileName : this.decodeFilenameFromUrl(url);
      this.downloadFromStream(fs, decodedFilename);
    });
  }
  getFileStream(url: string): Observable<any> {
    return this.http.get(url, {
      observe: 'response',
      responseType: 'arraybuffer'
    });
  }
  downloadFromStream(response: any, filename: string): void {
    const blob: Blob = new Blob([response.body], { type: response.headers.get('content-type') });
    filename = filename || response.headers.get('content-disposition').split(';')[0];
    const file: File = new File([blob], filename, { type: response.headers.get('content-type') });
    saveAs(file);
  }

  decodeFilenameFromUrl(url: string): string {
    const sections = url.split('/');
    const encodedFilename = sections[sections.length - 2];
    const decodedFilename = atob(encodedFilename);
    return decodedFilename;
  }
}
